const colors = {
    gray200: "#F7F7F9",
    gray300: "#E5E5EF",
    gray400: "#BABAC8",
    gray500: "#8C8DA0",
    gray600: "#555770",
    gray700: "#3C3E57",
    gray800: "#28293D",

    lightgray200: "#FCFCFD",

    pink200: "#FCE9F0",
    pink300: "#F5BCD3",
    pink400: "#EF8FB5",
    pink500: "#D27A9D",
    pink600: "#C65381",
    pink700: "#AC3967",
    pink800: "#862D50",

    red200: "#FBEAEA",
    red300: "#F2C0C0",
    red400: "#E99696",
    red500: "#D27979",
    red600: "#C65353",
    red700: "#A63F3F",
    red800: "#862D2D",

    orange200: "#FEF3E7",
    orange300: "#FBDCB6",
    orange400: "#F9C586",
    orange500: "#ED9F5E",
    orange600: "#E28436",
    orange700: "#CF6A17",
    orange800: "#AA5209",

    yellow200: "#FEFAE7",
    yellow300: "#FBF1B6",
    yellow400: "#F9E886",
    yellow500: "#F4E171",
    yellow600: "#F0D742",
    yellow700: "#ECCD13",
    yellow800: "#E5C400",

    teal200: "#E9FBFA",
    teal300: "#BEF4F0",
    teal400: "#93ECE6",
    teal500: "#79D3CD",
    teal600: "#3FC0B7",
    teal700: "#00A59A",
    teal800: "#077E76",

    lightblue200: "#E7F5FE",
    lightblue300: "#B6E2FB",
    lightblue400: "#86CFF9",
    lightblue500: "#55BAF6",
    lightblue600: "#30A5E8",
    lightblue700: "#2288C3",
    lightblue800: "#1B6A98",

    navyblue200: "#EBF1FA",
    navyblue300: "#C2D4F0",
    navyblue400: "#99B7E5",
    navyblue500: "#709ADB",
    navyblue600: "#4D7ECB",
    navyblue700: "#3465B2",
    navyblue800: "#284E8A",

    indigo200: "#E9EBFB",
    indigo300: "#BEC2F3",
    indigo400: "#939AEC",
    indigo500: "#7079DB",
    indigo600: "#5E69E7",
    indigo700: "#4752D1",
    indigo800: "#2E39B8",

    purple200: "#EFE7FD",
    purple300: "#CEB8F9",
    purple400: "#AD89F5",
    purple500: "#9167E4",
    purple600: "#713CDD",
    purple700: "#5722C3",
    purple800: "#441B98"
}

const variants = {
    primary: "#003E72",
    primary_hover: "#00325F",
    primary_focused: "#001D3E",
    primary_disabled: "#A4B2C8",

    text_section: colors.gray800,
    text_body: colors.gray600,
    text_disable: colors.gray400,
    text_error: "#F30020",

    bg_primary: "#F0F1F8",
    scrollbar_color: "rgb(193 193 193)",
    scrollbar_track_color: "transparent"
}

export default { ...variants, ...colors }
